import type { AuthDataResponse } from '@/domains/auth/auth.entity';
import type { AuthUserEntityStore } from '../models/authStore.model';

/**
 * Mapper para transformar datos de dominio a modelo de store
 * Responsabilidad: Convertir AuthResult (dominio) → AuthUserEntityStore (store)
 */
export const mapAuthResultToAuthUserEntityStore = (
  authResult: AuthDataResponse,
): AuthUserEntityStore => ({
  id: authResult.user.id,
  name: authResult.user.name, // Consistente con dominio
  email: authResult.user.email,
  run: authResult.user.run, // Agregado para completitud
  role: authResult.user.role,
  token: authResult.token,
  es_admin: authResult.user.es_admin,
  ultimo_acceso: authResult.user.ultimo_acceso,
  cod_tipo_perfil: authResult.user.cod_tipo_perfil,
  desc_tipo_perfil: authResult.user.desc_tipo_perfil,
});
